import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { authRedirectPath, silentAuthRedirectPath } from './app/authentication/AuthServiceProvider';
import AuthCallbackPage from './pages/auth/AuthCallbackPage';
import SilentAuthCallbackPage from './pages/auth/SilentAuthCallbackPage';
import ProtectedRoutes from './app/authentication/ProtectedRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <BrowserRouter>
          <Routes>
              <Route path={authRedirectPath} element={<AuthCallbackPage />} />
              <Route path={silentAuthRedirectPath} element={<SilentAuthCallbackPage />} />
              <Route path="*" element={<ProtectedRoutes />} />
          </Routes>
    </BrowserRouter>
  )
};

export default App;
